import 'twin.macro'

import React, { FC } from 'react'
import tw, { TwStyle } from 'twin.macro'

type SubTitleProps = {
  children: React.ReactNode
  variant?: 'bold' | 'regular' | 'medium'
  twStyle?: TwStyle
}
const textVariants = {
  bold: tw`font-bold`,
  regular: tw`font-normal`,
  medium: tw`font-medium`
} as { bold: TwStyle; regular: TwStyle; medium: TwStyle }

const styles = {
  text: ({ variant = 'regular', twStyle }: { variant?: 'bold' | 'regular' | 'medium'; twStyle?: TwStyle }) => [
    tw`sm:text-s18 text-s16`,
    textVariants[variant],
    twStyle
  ]
}

export const SubTitle: FC<SubTitleProps> = ({ children, variant, twStyle }) => {
  return <h2 css={styles.text({ variant, twStyle })}>{children}</h2>
}
export default SubTitle
